import { render, staticRenderFns } from "./help-center.vue?vue&type=template&id=35937339&scoped=true&"
import script from "./help-center.vue?vue&type=script&lang=js&"
export * from "./help-center.vue?vue&type=script&lang=js&"
import style0 from "./help-center.vue?vue&type=style&index=0&id=35937339&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35937339",
  null
  
)

export default component.exports